import { useIntl, type MessageDescriptor } from 'react-intl';
import { Typography, TypographyProps } from '@eventbrite/marmalade';
import React from 'react';

interface EventCardDateProps extends Omit<TypographyProps, 'children' | 'style'> {
    formattedDateString?: MessageDescriptor | string;
}

/**
 * Migrated from eb-ui on 2025/02/20. [304666f](https://github.com/eventbrite/eb-ui/tree/304666f0f6a504707986a0a82b185719918abb73/packages/attendee/event-renderer/src/components/EventCardDate)
 */
export const EventCardDate: React.FunctionComponent<EventCardDateProps> = (props) => {
    const { formattedDateString, ...typographyProps } = props;
    const { formatMessage } = useIntl();

    if (!formattedDateString) {
        return null;
    }

    if (typeof formattedDateString === 'string') {
        return <Typography {...typographyProps}>{formattedDateString}</Typography>;
    }

    return <Typography {...typographyProps}>{formatMessage(formattedDateString)}</Typography>;
};
